var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualaccountsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 213.12C128 166.101333 166.101333 128 213.12 128h597.76C857.898667 128 896 166.101333 896 213.12v597.76A85.12 85.12 0 0 1 810.88 896H213.12A85.12 85.12 0 0 1 128 810.88V213.12zM213.333333 213.333333v597.333334h597.333334V213.333333H213.333333z m126.805334 562.346667a425.941333 425.941333 0 0 1-74.709334-41.728A298.410667 298.410667 0 0 1 516.352 597.333333c102.4 0 192.725333 51.498667 246.528 130.005334a426.453333 426.453333 0 0 1-73.557333 43.733333A213.034667 213.034667 0 0 0 516.352 682.666667c-73.173333 0-137.813333 36.864-176.213333 93.013333zM512 554.666667a149.333333 149.333333 0 1 1 0-298.666667 149.333333 149.333333 0 0 1 0 298.666667z m0-85.333334a64 64 0 1 0 0-128 64 64 0 0 0 0 128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualaccountsvg);
export default __webpack_public_path__ + "static/media/virtualaccountsvg.f9968705d6f05daf2ab9496b26c3f107.svg";
export { ForwardRef as ReactComponent };